import api from 'api/apiClient';
import { formatDate } from 'modules/shared/utils';
import { API_VOUCHER_STATUS_KEYS } from '../constants';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function getAdminVouchers() {
  const { data: raw } = await unwrap(await api.get('/api/hr/reimbursement-requests'));

  const normalized = {
    pending: [],
    approved: [],
    rejected: [],
    paid: [],
  };

  raw.forEach((voucher) => {
    const uiStatus = API_VOUCHER_STATUS_KEYS[voucher.status];
    if (!uiStatus) return;

    normalized[uiStatus].push({
      id: voucher.id,
      employeeId: voucher.employee_id,
      employeeName: voucher.employee_name,
      department: voucher.department,
      expenseType: voucher.expense_type,
      status: uiStatus,
      amountRequested: voucher.amount_requested,
      amountReimbursed: voucher.amount_reimbursed,
      rejectionReason: voucher.reason_for_rejection,
      employeeNote: voucher.comment,
      attachmentUrl: voucher.document?.url ?? null,
      appliedOn: formatDate(voucher.applied_on),
      dateOfEvent: formatDate(voucher.date_of_event),
    });
  });

  return normalized;
}

export async function approveVoucher(id, amountReimbursed, adminId) {
  if (!id || !amountReimbursed || !adminId) throw new Error('Invalid voucher data for approval');

  const payload = {
    reimbursement_id: id,
    amount_reimbursed: amountReimbursed,
    handled_by: adminId,
    status: 'Accepted',
  };

  await unwrap(await api.put('/api/hr/reimbursement-update', payload));
}

export async function rejectVoucher(id, reason, adminId) {
  if (!id || !reason || !adminId) throw new Error('Invalid voucher data for rejection');

  const payload = {
    reimbursement_id: id,
    handled_by: adminId,
    status: 'Rejected',
    rejection_reason: reason,
  };

  await unwrap(await api.put('/api/hr/reimbursement-update', payload));
}
